import React, { MouseEventHandler } from 'react';
import Button from '../Button';

import styles from './styles.module.css';

interface ConfirmationProps {
  children: React.ReactNode;
  confirmHandler?: MouseEventHandler;
  cancelHandler?: MouseEventHandler;
}

const Confirmation = (props: ConfirmationProps) => {
  return (
    <div className={styles['confirmation']}>
      <h1>{props.children}</h1>
      <div className={styles['buttons']}>
        <Button secondary color='silver' onClick={props.cancelHandler}>No, Cancel</Button>
        <Button secondary color='yellow' onClick={props.confirmHandler}>Yes, Restart</Button>
      </div>
    </div>
  );
};

export default Confirmation;